export const isDepositOrCashoutPage = (): boolean => {
    const {pathname} = window.location;

    return Boolean(pathname.includes('/deposits') || pathname.includes('/withdraws'));
};
